// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"primaryColor": "#f57c00",
	"lightPrimary": "#f49435",
	"secondaryColor": "#0d1117",
	"lightSecondary": "#18263a"
};
module.exports = exports;
